import { atom } from 'jotai';
import { Country } from '../types/common';

export const countriesAtom = atom<Country[]>([]);
